import classes from './styles.module.scss'
import { RIBBON_BLUE } from '../../constants/colors'
import React from 'react'

interface Props {
  color?: string
  label: string
  checked: boolean
  onChange: (a: boolean) => void
}

const Checkbox: React.FC<Props> = ({ color, label, checked, onChange }) => {
  const style: { [key: string]: string } = {
    '--theme-color': color || RIBBON_BLUE,
  }

  const handleChange = () => {
    onChange(!checked)
  }

  return (
    <div className={classes.container} onClick={handleChange}>
      {label}
      <input type="checkbox" checked={checked} onChange={handleChange}/>
      <span className={classes.checkmark} style={style} />
    </div>
  )
}

export default Checkbox
